export const TABLE_FILTER_TITLE = [
  {
    label: 'library.savePortfolio.COMPANY',
    key: 'organizationName',
  },
  {
    label: 'library.detailsPortfolios.TAX_CODE',
    key: 'taxCode',
  },
  {
    label: 'library.detailsPortfolios.STATUS',
    key: 'status',
  },
  {
    label: 'library.filterCompanies.CREDIT_SCORE',
    key: 'creditRiskScore',
  },
  {
    label: 'library.filterCompanies.PERFORMANCE_SCORE',
    key: 'performanceScore',
  },
  {
    label: 'library.detailsPortfolios.DATE_DOWNLOADED',
    key: 'deliveryDate',
  },
]

export const SCORE_TYPE = {
  CREDIT_RISK: 'CREDIT_RISK',
  PERFORMANCE: 'PERFORMANCE',
}

export const PERFORMANCE_SCORE_COLOR = [
  '#EB6671',
  '#FFDE86',
  '#C3D785',
  '#87D4A4',
]
